export var GuestStatus;
(function (GuestStatus) {
    GuestStatus["VIP"] = "VIP";
    GuestStatus["BLACKLIST"] = "BLACKLIST";
})(GuestStatus || (GuestStatus = {}));
